import React from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";

export default function Pagination({
  pageCount,
  handlePageClick,
  currentPageNumber,
  totalResult,
  limit,
  offset,
}) {
  const start = offset + 1;
  const end = Math.min(start + limit - 1, totalResult);

  return (
    <>
      <div className="pagination-wrapper">
        <p className="pagination-text">
          Showing {start} - {end} out of {totalResult} result(s)
        </p>
      </div>
      <ReactPaginate
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        forcePage={currentPageNumber}
      />
    </>
  );
}
